// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"5201f112","396":"e0240847","421":"25b1d5ea","655":"493e975e","831":"1ab88520","981":"b2eb78a6"}[chunkId] + ".chunk.css";
};